import { useCallback } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

export function usePageTutorial(pageId, steps) {
  const storageKey = `tutorial_done_${pageId}`;

  const startTutorial = useCallback((force = false) => {
    if (!steps?.length) return;
    if (!force && localStorage.getItem(storageKey)) return;

    const d = driver({
      showProgress: true,
      allowClose: true,
      overlayOpacity: 0.6,
      nextBtnText: 'Avanti',
      prevBtnText: 'Indietro',
      doneBtnText: 'Fine',
      steps,
      onDestroyed: () => {
        if (!force) localStorage.setItem(storageKey, '1');
      },
    });
    d.drive();
  }, [pageId, steps, storageKey]);

  const resetTutorial = useCallback(() => {
    localStorage.removeItem(storageKey);
    startTutorial(true);
  }, [storageKey, startTutorial]);

  return { startTutorial, resetTutorial, storageKey };
}

export function TutorialButton({ onStart, className = '' }) {
  return (
    <button
      type="button"
      className={className || 'btn btn-sm btn-outline-secondary'}
      onClick={() => onStart(true)}
      title="Guida pagina"
    >
      <i className="bi bi-question-circle" /> Guida
    </button>
  );
}
